const to = (promise: any) => {
    return promise.then((data: any) => {
        return {
            error: null,
            result: data,
        };
    }).catch((err: any) => {
        return {
            error: err.response,
            result: null
        };
    });
}; // full response object

const toData = (promise: any) => {
    return promise.then((data: any) => {
        return {
            error: null,
            result: data.data,
        };
    }).catch((err: any) => {
        return {
            error: err.response,
            result: null
        };
    });
}; // only response data

// const handleError = (error: any) => {
//     const status = error.response.status;
//     if (status === 401) {
//         console.log(error.response);
//         alert(error.response.data.rsltComment);
//         // auth.clearAuth();
//         // router.push('/login');
//         // window.location.reload();
//     }
// };

export {
    to,
    toData,
    // handleError,
};
